import React from 'react';
import { useTheme, useMediaQuery } from '@material-ui/core';

import styles from './FabTitle.module.css';

import logo1 from 'assets/img/fab_logo.png';
import logo2 from 'assets/icons/sidemenus-PNG/FABLOGO.png';

const FabTitle = () => {
  const theme = useTheme();
  const showLogo = useMediaQuery(theme.breakpoints.down('lg'));
  const logo = useMediaQuery(theme.breakpoints.down('sm')) ? logo1 : logo2;

  return (
    <div className={styles.content}>
      {showLogo && <img src={logo} alt="FAB logo" className={styles.img} />}
      <div className={styles.separator} />
      <div className={styles.title}>
        <div>First Atlantic</div>
        <div>Corporate Internet</div>
        <div>Banking</div>
      </div>
    </div>
  );
};

export default FabTitle;
